import request from 'utils/request';

export const products = {
  search: ({ sku, brands }) =>
    request.get(`/products`, { search: sku, brands }),
  filter: (filters) => request.get('/products', filters),
  get: (id) => request.get(`/products/${id}`),
};

export const distributors = {
  list: () => request.get('/products/distributors'),
};

export const distributorAvailability = {
  get: (data) => request.post('/products/distributor_availability', data),
};

export const preferredDistributors = {
  list: () => request.get('/products/preferred_distributors'),
  update: (data) => request.post('/products/preferred_distributors', data),
};

export const presentation = {
  get: (id) => request.get(`/products/${id}/presentation`),
};

export const productAvailability = {
  get: (data) => request.post('/products/bulk_product_availability', data),
};

export const rfq = {
  send: (data) => request.post(`/products/rfq`, data),
};

export const partPurchasedComponentSearch = {
  post: (rootPartId, data, brands = null) =>
    request.post(`/parts/${rootPartId}/purchased_component_search`, {
      ...data,
      brands,
    }),
};
